const ModelVendors = {
  OPENAI: "OPENAI",
  ANTHROPIC: "ANTHROPIC",
  NEBIUS: "NEBIUS",
  //AMAZON: "AMAZON",
};

export default ModelVendors;
